import { useQuery } from '@apollo/react-hooks';
import { RETRIEVE_DEFAULT_COUPON_MAPPING } from '../../graphql/quotation';
import { ApiError } from '../../error';

const useRetrieveDefaultCouponMapping = (type, options) => {
  var _retrieve$data;

  const retrieve = useQuery(RETRIEVE_DEFAULT_COUPON_MAPPING, {
    variables: type ? {
      type
    } : undefined,
    ...options
  });

  if (retrieve.error) {
    throw new ApiError(retrieve.error.message);
  }

  return [(_retrieve$data = retrieve.data) === null || _retrieve$data === void 0 ? void 0 : _retrieve$data.defaultCouponMapping, retrieve];
};

export default useRetrieveDefaultCouponMapping;